
/*!
 * input-utils v1.0.0 - ES Module source
 * Generated by ChatGPT for user - Build Pro
 */
const util = {
  onlyNumbers: v => (v||'').toString().replace(/\D/g,''),
  debounce: (fn, wait) => {
    let t;
    return function(){
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(ctx, args), wait);
    };
  },
  setCaretToEnd: el => { try { const l = el.value.length; el.setSelectionRange(l,l); } catch(e){} }
};

const inputUtils = {
  version: '1.0.0',
  defaults: {
    blockPaste: true,
    allowPasteButClean: false,
    normalize: true,
    autoMask: true,
    debounce: 8,
    strict: true,
    placeholder: true,
    integrateJQueryValidate: false,
    callbacks: {
      onChange: null,
      onFilled: null,
      onInvalid: null,
      onMaskApplied: null,
      onClean: null
    },
    mobile: { forceNumericKeyboard: true }
  },
  _masks: {},
  _validators: {},
  rgStateMap: {
    'AC':9,'AL':9,'AP':9,'AM':9,'BA':8,'CE':9,'DF':9,'ES':8,'GO':9,'MA':9,'MT':9,'MS':8,'MG':9,'PA':8,'PB':8,'PR':9,'PE':9,'PI':9,'RJ':8,'RN':8,'RS':9,'RO':8,'RR':8,'SC':9,'SP':9,'SE':8,'TO':8
  }
};

// register masks and validators (kept concise)
function registerDefaultMasks(uUtils, iu) {
  const m = iu._masks;
  m.cpf = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,11);
    if(!applyMask) return raw;
    return raw.replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})$/,"$1-$2");
  };
  m.cnpj = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,14);
    if(!applyMask) return raw;
    return raw.replace(/^(\d{2})(\d)/,"$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3").replace(/\.(\d{3})(\d)/,".$1/$2").replace(/(\d{4})(\d)/,"$1-$2");
  };
  m.pis = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,11);
    if(!applyMask) return raw;
    return raw.replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})$/,"$1-$2");
  };
  m.cep = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,8);
    if(!applyMask) return raw;
    return raw.replace(/(\d{5})(\d)/,"$1-$2");
  };
  m.telefone = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,11);
    if(!applyMask) return raw;
    if(raw.length<=10) return raw.replace(/(\d{2})(\d)/,"($1) $2").replace(/(\d{4})(\d)/,"$1-$2");
    return raw.replace(/(\d{2})(\d)/,"($1) $2").replace(/(\d{5})(\d)/,"$1-$2");
  };
  m.data = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,8);
    if(!applyMask) return raw;
    return raw.replace(/(\d{2})(\d)/,"$1/$2").replace(/(\d{2})(\d)/,"$1/$2");
  };
  m.documento = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length<=11) return m.cpf(raw, applyMask);
    return m.cnpj(raw, applyMask);
  };
  m.placa = function(raw, applyMask){
    raw = (raw||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,7);
    if(!applyMask) return raw;
    if(/^[A-Z]{3}\d{4}$/.test(raw)) return raw.replace(/^([A-Z]{3})(\d{4})$/,"$1-$2");
    if(/^[A-Z]{3}\d[A-Z]\d{2}$/.test(raw)) return raw;
    return raw;
  };
  m.cartao = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,19);
    if(!applyMask) return raw;
    return raw.replace(/(\d{4})(?=\d)/g,"$1 ");
  };
  m.hora = function(raw, applyMask){
    raw = uUtils.onlyNumbers(raw).slice(0,4);
    if(!applyMask) return raw;
    return raw.replace(/(\d{2})(\d)/,"$1:$2");
  };
  m.rg = function(raw, applyMask){
    raw = (raw||'').toUpperCase().replace(/[^0-9X]/g,'').slice(0,12);
    if(!applyMask) return raw;
    if(raw.length<=2) return raw;
    if(raw.length<=5) return raw.replace(/(\d{2})(\d+)/,"$1.$2");
    if(raw.length<=8) return raw.replace(/(\d{2})(\d{3})(\d+)/,"$1.$2.$3");
    return raw.replace(/(\d{2})(\d{3})(\d{3})(\w+)/,"$1.$2.$3-$4");
  };
}

function registerValidators(uUtils, iu){
  const v = iu._validators;
  v.cpf = function(raw){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length!==11) return false;
    if(/^(\d)\1+$/.test(raw)) return false;
    let sum=0, rest;
    for(let i=1;i<=9;i++) sum += parseInt(raw.substring(i-1,i)) * (11 - i);
    rest = (sum * 10) % 11; if(rest===10) rest=0;
    if(rest!==parseInt(raw.substring(9,10))) return false;
    sum=0;
    for(let i=1;i<=10;i++) sum += parseInt(raw.substring(i-1,i)) * (12 - i);
    rest = (sum * 10) % 11; if(rest===10) rest=0;
    return rest === parseInt(raw.substring(10,11));
  };
  v.cnpj = function(raw){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length!==14) return false;
    if(/^(\d)\1+$/.test(raw)) return false;
    const t = raw.length - 2, d = raw.substring(t);
    const calc = function(x){
      let s=0;
      for(let i=x;i>=1;i--) s += raw.charAt(x-i) * (i%8+2);
      const r = s%11; return r<2?0:11-r;
    };
    const v1 = calc(12); if(v1 !== parseInt(d.charAt(0))) return false;
    const v2 = calc(13); return v2 === parseInt(d.charAt(1));
  };
  v.pis = function(raw){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length!==11) return false;
    const mult = [3,2,9,8,7,6,5,4,3,2];
    let s=0;
    for(let i=0;i<10;i++) s += parseInt(raw.charAt(i)) * mult[i];
    let r = 11 - (s % 11); if(r===10||r===11) r=0;
    return r === parseInt(raw.charAt(10));
  };
  v.cep = function(raw){ raw = uUtils.onlyNumbers(raw); return raw.length===8; };
  v.data = function(raw){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length!==8) return false;
    const d = parseInt(raw.slice(0,2),10), m = parseInt(raw.slice(2,4),10), y = parseInt(raw.slice(4),10);
    if(m<1||m>12) return false;
    const days = [31, ((y%4===0 && y%100!==0) || (y%400===0))?29:28,31,30,31,30,31,31,30,31,30,31];
    return d>=1 && d<=days[m-1];
  };
  v.telefone = function(raw){ raw = uUtils.onlyNumbers(raw); return raw.length>=10 && raw.length<=11; };
  v.documento = function(raw){ raw = uUtils.onlyNumbers(raw); if(raw.length===11) return v.cpf(raw); if(raw.length===14) return v.cnpj(raw); return false; };
  v.placa = function(raw){ raw = (raw||'').toUpperCase().replace(/[^A-Z0-9]/g,''); if(/^[A-Z]{3}\d{4}$/.test(raw)) return true; if(/^[A-Z]{3}\d[A-Z]\d{2}$/.test(raw)) return true; return false; };
  v.cartao = function(raw){
    raw = uUtils.onlyNumbers(raw);
    if(raw.length<12) return false;
    let sum=0, alt=false;
    for(let i=raw.length-1;i>=0;i--){
      let d = parseInt(raw.charAt(i)); if(alt) d*=2; if(d>9) d-=9; sum+=d; alt=!alt;
    }
    return sum%10===0;
  };
  v.rg = function(raw, state){
    raw = (raw||'').toUpperCase().replace(/[^0-9X]/g,'');
    if(!raw) return false;
    if(raw.length<7 || raw.length>12) return false;
    if(state && iu.rgStateMap && iu.rgStateMap[state]){
      const expected = iu.rgStateMap[state]; if(expected && raw.length !== expected) return false;
    }
    return true;
  };
}

registerDefaultMasks(util, inputUtils);
registerValidators(util, inputUtils);

// Export a function to attach as jQuery plugin
function initJQueryPlugin($, optionsOrMethod){
  // The plugin implementation mirrors previous code but simplified for modular source
  $.fn.inputUtils = function(optionsOrMethod){
    if(typeof optionsOrMethod === 'string'){
      const method = optionsOrMethod;
      const args = Array.prototype.slice.call(arguments,1);
      const el = this[0];
      if(!el) return null;
      if(method==='isValid'){
        const cfg = $(el).data('inputUtils_cfg') || inputUtils.defaults;
        const maskType = $(el).data('mask') || $(el).data('inpututils-mask-detected');
        let val = $(el).val() || '';
        if(cfg.normalize && inputUtils._masks[maskType]) val = inputUtils._masks[maskType](val,false);
        else val = util.onlyNumbers(val);
        const validator = inputUtils._validators[maskType] || null;
        if(validator) return validator(val);
        if(maskType==='documento') return inputUtils._validators.documento(val);
        return true;
      } else if(method==='raw'){
        const v = $(el).val(); if(!v) return v;
        const maskType2 = $(el).data('mask') || $(el).data('inpututils-mask-detected');
        if(inputUtils._masks[maskType2]) return inputUtils._masks[maskType2](v,false);
        return util.onlyNumbers(v);
      } else if(method==='clean'){ $(el).val(''); return this; }
      else if(method==='applyMask'){ const m = args[0] || $(el).data('mask') || $(el).data('inpututils-mask-detected'); const cur = $(el).val()||''; if(inputUtils._masks[m]) $(el).val(inputUtils._masks[m](cur,true)); return this; }
      return null;
    }

    const userOpts = optionsOrMethod || {};
    const cfgGlobal = $.extend(true, {}, inputUtils.defaults, userOpts);

    return this.each(function(){
      const $input = $(this); const el = this; const cfg = $.extend(true, {}, cfgGlobal);
      $input.data('inputUtils_cfg', cfg);
      let maskType = $input.data('mask');
      if(!maskType && cfg.autoMask){
        const combined = (($input.attr('name')||'') + ' ' + ($input.attr('id')||'') + ' ' + ($input.attr('placeholder')||'') + ' ' + ($input.attr('class')||'')).toLowerCase();
        let guess = null;
        if(/cpf/.test(combined)) guess='cpf'; else if(/cnpj/.test(combined)) guess='cnpj'; else if(/cep/.test(combined)) guess='cep';
        else if(/tel|telefone|celular|phone/.test(combined)) guess='telefone'; else if(/data|date|dta/.test(combined)) guess='data';
        else if(/doc|documento|cpfcnpj|documento/.test(combined)) guess='documento'; else if(/rg/.test(combined)) guess='rg';
        else if(/pis/.test(combined)) guess='pis'; else if(/placa/.test(combined)) guess='placa';
        if(guess) maskType = guess;
      }
      if(maskType) $input.data('inpututils-mask-detected', maskType);

      if(cfg.mobile && cfg.mobile.forceNumericKeyboard){
        if(['cpf','cnpj','telefone','cep','data','cartao','pis'].indexOf(maskType)!==-1){
          try{ $input.attr('inputmode','numeric'); $input.attr('pattern','\\d*'); }catch(e){}
        }
      }

      if(cfg.placeholder && maskType && inputUtils._masks[maskType]){
        let ph = '';
        switch(maskType){
          case 'cpf': ph='___.___.___-__'; break;
          case 'cnpj': ph='__.___.___/____-__'; break;
          case 'cep': ph='_____-___'; break;
          case 'telefone': ph='(__) _____-____'; break;
          case 'data': ph='dd/mm/aaaa'; break;
          case 'documento': ph='CPF ou CNPJ'; break;
          case 'cartao': ph='____ ____ ____ ____'; break;
          case 'rg': ph='__.___.___-__'; break;
          default: ph = $input.attr('placeholder')||'';
        }
        if(!$input.attr('placeholder')) $input.attr('placeholder', ph);
      }

      const process = function(evSource){
        let val = $input.val() || '';
        if(cfg.normalize){
          const mt = $input.data('mask') || $input.data('inpututils-mask-detected');
          if(mt && inputUtils._masks[mt]){
            val = inputUtils._masks[mt](val,false);
            if(cfg.autoMask) val = inputUtils._masks[mt](val,true);
          } else {
            val = util.onlyNumbers(val);
          }
        }
        const prev = $input.data('inpututils-last-val') || '';
        if(val !== prev){
          $input.val(val); $input.data('inpututils-last-val', val);
          if(typeof cfg.callbacks.onChange === 'function') cfg.callbacks.onChange.call(el, val, el);
          const mt2 = $input.data('mask') || $input.data('inpututils-mask-detected');
          let filled = false;
          if(mt2 && inputUtils._masks[mt2]){
            const raw = inputUtils._masks[mt2](val,false);
            const maxlen = { cpf:11, cnpj:14, cep:8, telefone:11, data:8, cartao:19, pis:11 }[mt2] || null;
            if(maxlen && raw.length >= maxlen) filled = true;
          }
          if(filled && typeof cfg.callbacks.onFilled === 'function') cfg.callbacks.onFilled.call(el, val, el);
          if(mt2 && inputUtils._validators[mt2]){
            const ok = inputUtils._validators[mt2](inputUtils._masks[mt2](val,false));
            if(!ok && typeof cfg.callbacks.onInvalid === 'function') cfg.callbacks.onInvalid.call(el, val, el);
          }
        }
      };

      const processDebounced = util.debounce(process, cfg.debounce);

      $input.on('keydown.inputUtils', function(e){
        const allowed = [46,8,9,27,13,35,36,37,38,39,40];
        if(allowed.indexOf(e.keyCode)!==-1) return;
        if(e.ctrlKey||e.metaKey) return;
        const isNumber = (!e.shiftKey && e.keyCode>=48 && e.keyCode<=57) || (e.keyCode>=96 && e.keyCode<=105);
        const maskNow = $input.data('mask') || $input.data('inpututils-mask-detected');
        if((cfg.normalize || maskNow) && !isNumber) e.preventDefault();
      });

      $input.on('paste.inputUtils drop.inputUtils', function(e){
        if(cfg.blockPaste){ e.preventDefault(); return false; }
        else if(cfg.allowPasteButClean){ setTimeout(()=>processDebounced('paste'),0); }
        else { setTimeout(()=>processDebounced('paste'),0); }
      });

      $input.on('input.inputUtils', ()=>processDebounced('input'));

      $input.on('beforeinput.inputUtils', function(ev){ if(!cfg.strict) return; try{ const it = ev.originalEvent.inputType; if(it && (it.indexOf('insertFromPaste')!==-1 || it.indexOf('insertFromDrop')!==-1)){ if(cfg.blockPaste) ev.preventDefault(); } }catch(err){} });

      $input.on('focus.inputUtils', function(){ processDebounced('focus'); setTimeout(()=>util.setCaretToEnd(el),0); });

      try{
        let last = $input.val();
        const mo = new MutationObserver(function(){ const cur = $input.val(); if(cur !== last){ last = cur; processDebounced('mutation'); } });
        mo.observe(el, { attributes: true, attributeFilter: ['value'] });
        $input.data('inputUtils_mutationObserver', mo);
      }catch(e){}

      processDebounced('init');

      if(cfg.integrateJQueryValidate && $.validator){
        const mt = $input.data('mask') || $input.data('inpututils-mask-detected');
        if(mt && inputUtils._validators[mt]){
          if(!$.validator.methods['inpututils_'+mt]){
            $.validator.addMethod('inpututils_'+mt, function(value, element){
              if(!value) return true;
              const raw = inputUtils._masks[mt](value,false);
              return inputUtils._validators[mt](raw);
            }, 'Valor inválido.');
          }
          $input.rules('add', { ['inpututils_'+mt]: true });
        }
      }

      $input.data('inputUtils_initialized', true);
    });
  };
}

// Export module API
export { inputUtils, util, initJQueryPlugin };
